import React, { FC } from 'react';
import { Route, Router, Switch, useHistory } from 'react-router';

import { useMfaSessionDetailsQuery } from 'src/apps/mfa/hooks/useMfaSessionDetailsQuery';
import { useSetMfaBreadcrumbs } from 'src/apps/mfa/hooks/useSetMfaBreadcrumbs';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { hasLicenseForProduct } from 'src/common/services/CommonDashboardService';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { NotFound404Page } from '../../../common/pages/not-found-404-page/NotFound404Page';
import { Unauthorized403Page } from '../../../common/pages/unauthorized-403-page/Unauthorized403Page';
import { getSessionIdParam } from '../../../common/services/breadcrumbs/MfaUrlService';
import { HtmlReport } from '../../mobile-common/pages/html-report/HtmlReport';
import { DashboardContainerMfa } from '../pages/dashboard-container/DashboardContainerMfa';
import { MfaSingleIssuePage } from '../pages/single-issue/MfaSingleIssuePage';
import { MfaSingleSessionPage } from '../pages/single-session/MfaSingleSessionPage';

const productType = ProductType.MOBILE_FLOW_ANALYZER;
const SESSION_ID_KEY = ':sessionId';
const ISSUE_ID_KEY = ':issueId';

const MfaSessionReportSessionGate: FC = () => {
	const { tenant } = useUserTenant();
	const { location } = useHistory();
	const hasLicense = hasLicenseForProduct(tenant, productType);

	const sessionId = getSessionIdParam(location);

	const sessionDetailsQuery = useMfaSessionDetailsQuery(sessionId);

	const { sessionName } = sessionDetailsQuery.data ?? {};

	useSetMfaBreadcrumbs(sessionId, sessionName);

	return hasLicense ? <HtmlReport sessionId={sessionId} /> : <Unauthorized403Page />;
};

export const MfaRouter: FC = () => {
	const history = useHistory();
	return (
		<Router history={history}>
			<Switch>
				<Route
					exact
					path={RoutesHelper.getMfaSessionPath(SESSION_ID_KEY, SessionViews.OVERVIEW)}
					render={() => <MfaSingleSessionPage viewId={SessionViews.OVERVIEW} />}
				/>
				<Route
					exact
					path={RoutesHelper.getMfaSessionPath(SESSION_ID_KEY, SessionViews.ALL_ISSUES)}
					render={() => <MfaSingleSessionPage viewId={SessionViews.ALL_ISSUES} />}
				/>
				<Route
					exact
					path={RoutesHelper.getMfaIssueInfoPath({
						runId: SESSION_ID_KEY,
						issueId: ISSUE_ID_KEY
					})}
					render={() => <MfaSingleIssuePage />}
				/>
				<Route
					exact
					path={RoutesHelper.getMfaSessionRootPath(SESSION_ID_KEY)}
					render={() => <MfaSingleSessionPage viewId={SessionViews.OVERVIEW} />}
				/>
				<Route exact path={RoutesHelper.getMfaDashboardPath()} component={DashboardContainerMfa} />
				<Route
					exact
					path={RoutesHelper.getMfaSessionReportPathname()}
					render={() => <MfaSessionReportSessionGate />}
				/>
				<Route render={() => <NotFound404Page />} />
			</Switch>
		</Router>
	);
};
